export default __webpack_public_path__ + "static/media/Spotify_logo.svg.d4a3f470.png";